import { Alert, Link, Stack, Typography } from '@mui/material'

const HELP_PAGE_URL =
  'https://docs.channel.io/kaminashireport/ja/categories/AIラベル検査-da0fb44f?utm_source=admin&utm_medium=menu'

export const Tips = () => {
  return (
    <Alert severity="info" sx={{ mt: 1 }}>
      <Stack direction="column" alignItems="flex-start" spacing={1}>
        <Typography variant="h6" fontWeight="bold" fontSize={16}>
          設定のコツ
        </Typography>
        <Typography
          variant="body2"
          component="ol"
          sx={{
            pl: 4,
            listStyleType: 'decimal',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <li>
            あまりたくさんの内容を囲いすぎないようにしてください。（文字を囲う場合は2行ぐらいまでにしてください）
          </li>
          <li>
            ラベル情報の位置の特定のため「見た目」一致は必ず一つ以上作成してください。
          </li>
          <li>
            判定箇所が多いと重くなります。4個以内程度がサクサク動く範囲です。
          </li>
        </Typography>
        <Typography variant="body2">
          くわしくは
          <Link href={HELP_PAGE_URL} target="_blank" rel="noopener noreferrer">
            ヘルプページ
          </Link>
          をご確認ください。
        </Typography>
      </Stack>
    </Alert>
  )
}
